module.exports = __webpack_public_path__ + "media/images/logo_pink-f0627b47a01a2362128e3e353b0b8042.svg";